<template>
    <div :id="`lm-form-portal-builder-ui-${id}`" class="row">
      <LmTextInput
        :id="`name-${id}`"
        class="col-12 col-md-4"
        v-model="component.componentProps.name"
        @input="$emit('input', component)"
        label="Name"
        placeholder="portal-1"
      />
      <LmSelect
        :id="id + 'css'"
        class="col-12 col-md-4"
        v-model="component.class"
        :options="{
          content: [
            {value: 'col-12 col-md-3',text: '25%'},
            {value: 'col-12 col-md-6', text: '50%'},
            {value: 'col-12 col-md-9', text: '75%'},
            {value: 'col-12 col-md-12', text: '100%'}
          ]
        }"
        label="Ancho vista escritorio"
        :help="$t('help_width_form_element')"
        @input="$emit('input', component)"
      />
    </div>
</template>

<script>
import LmTextInput from '@/components/form/elements/LmTextInput'
import LmSelect from '@/components/form/elements/LmSelect'

export default {
  data () {
    return {
      component: {}
    }
  },
  components: {
    LmTextInput,
    LmSelect
  },
  props: {
    id: {
      type: [String, Number],
      default: ''
    },
    componentData: {
      type: Object,
      default: () => (
        {
          class: 'col-12 col-md-6',
          componentName: 'LmPortalTarget',
          componentProps: {
            name: '',
            slim: true
          }
        }
      )
    }
  },
  created () {
    this.component = this.componentData
  }
}
</script>
